<template>
	<section class="service">
		<van-nav-bar title="客服咨询" left-arrow class="top_bar" @click-left="backFn" />	
		<div class="wx_code">
			<img src="../../../assets/img/kefu.jpg">
		</div>
		<div class="saveImg" @click="downs">
			<span>点击开始微信咨询</span>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav"
import Clipboard from "clipboard";
import { Notify,Dialog } from 'vant';

export default {
	name: 'service',
	components: {
		Nav,
	},
	data() {
		return {
			wxCodeImg: 'https://work.weixin.qq.com/ca/cawcded59657f71c3a',
			code: '',
            clientType: '',
		}
	},
	created() {
        this.clientType = this.$store.state.clientType
		this.code = localStorage.getItem('code')||''
		this.getInfo()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getInfo() {
		},
		downs () {
            if(window.plus) {
                // App环境：使用plus API打开外部浏览器（Safari/Chrome）
                plus.runtime.openURL(this.wxCodeImg);
            } else {
                // 浏览器环境：使用window.open打开新标签页
                window.open(this.wxCodeImg, '_blank', 'noopener,noreferrer');
            }
    	},

		copyFn() {
			if(this.$store.state.isIos) {
				var clipboard = new Clipboard(".tagRead");
				clipboard.on("success", e => {
					Notify({ type: 'success', message: '复制成功' });
					// 释放内存
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					// 不支持复制
					Notify({ type: 'danger', message: '复制失败' });
					// 释放内存
					clipboard.destroy();
				});
			}else {
				var oInput = document.createElement('input'); //创建一个input
				oInput.setAttribute("readonly", "readonly");//设置只读，否则移动端使用复制功能时可能会造成软件盘弹出
				oInput.value = this.code;
				document.body.appendChild(oInput);//将input插入到body
				oInput.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				oInput.style.display='none'; // 将input隐藏
				oInput.remove(); // 将input销毁
				Notify({ type: 'success', message: '复制成功' });
			}

    	},

		backFn() {
			this.$router.push({name:'setting'})
		},
	}
}
</script>

<style lang="scss">
	.service {
		padding-top: 46px;
		.wx_code {
			width: 160px;
			height: 160px;
			margin: 0 auto;
			margin-top: 64px;
			margin-bottom: 38px;
			background: #fff;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 95%;
			}
		}
		.saveImg {
			position: relative;
			font-size: 16px;
			margin: 0 auto;
			font-weight: bold;
			color: #fff;
			height: 36px;
			line-height: 36px;
			text-align: center;
			width: 160px;
			border-radius: 18px;
			background: #000;
			background: #3A5EEC;
			display: flex;
			align-items: center;
			justify-content: center;
			a {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				z-index: 2;
				opacity: 0;
				border-radius: 18px;
			}
			img {
				width: 19px;
				margin-right: 2px;
			}
		}
		.wx_num {
			padding-top: 37px;
			text-align: center;
			i {
				display: block;
				font-style: normal;
				color: #2B2F3A;
				font-size: 16px;
				padding-bottom: 9px;
			}
			p {
				.copyValue {
					position: absolute;
					z-index: -1;
					opacity: 0;
				}
				span {
					color: #2B2F3A;
					font-size: 16px;
					display: inline-block;
				}
				.tagRead {
					color: #3A5EEC;
					font-size: 15px;
					// margin-left: 6px;
					border: 0;
					background: transparent;
					
				}
			}
		}
		.workWeixin {
			position: relative;
			font-size: 16px;
			margin: 0 auto;
			font-weight: bold;
			color: #fff;
			height: 36px;
			line-height: 36px;
			text-align: center;
			width: 160px;
			border-radius: 18px;
			background: #000;
			background: #3A5EEC;
			display: flex;
			align-items: center;
			justify-content: center;
			a {
				color: #fff;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/service/Service.vue